import config from './config';

export default function checkAdmin(props, username) {
    let AWS = require('aws-sdk');

    var params = {
        UserPoolId: process.env.REACT_APP_USER_POOL,
        Username: username
    };

    AWS.config.update(config);

    var cog = new AWS.CognitoIdentityServiceProvider();

    cog.adminListGroupsForUser(params, function (err, data) {
        if (err) console.log(err, err.stack); // an error occurred
        else props(data);           // successful response
    });
}